import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  viewChild,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FieldOkComponent } from '@softline/dynamic';
import { DefaultFieldOkConfiguration } from '../field-ok-configuration';
import { FieldOkWrapper } from '../field-ok-wrapper';

@Component({
  selector: 'soft-lieferant-field-ok',
  imports: [FieldOkComponent],
  templateUrl: './lieferant-field-ok.component.html',
  styleUrl: './lieferant-field-ok.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LieferantFieldOkComponent),
      multi: true,
    },
  ],
})
export class LieferantFieldOkComponent
  extends FieldOkWrapper<DefaultFieldOkConfiguration>
  implements ControlValueAccessor
{
  readonly fieldOkComponent = viewChild.required(FieldOkComponent);
  override value = input<object | null>(null);
  override configuration = input<DefaultFieldOkConfiguration | null>(null);
  override parameters = input<object>({});
  override readonly = input<boolean>(false);
}
